var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3534_1881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66643 8.66666C6.95272 9.04942 7.31798 9.36612 7.73743 9.59529C8.15687 9.82446 8.6207 9.96074 9.09744 9.99489C9.57419 10.029 10.0527 9.96024 10.5005 9.79319C10.9483 9.62613 11.355 9.36471 11.6929 9.02666L13.6928 7.02666C14.3 6.39799 14.636 5.55598 14.6284 4.68199C14.6208 3.808 14.2703 2.97196 13.6522 2.35394C13.0342 1.73591 12.1982 1.38535 11.3243 1.37775C10.4503 1.37016 9.60833 1.70614 8.97968 2.31333L7.83306 3.45333M9.333 7.33333C9.04671 6.95058 8.68145 6.63388 8.26201 6.4047C7.84256 6.17553 7.37873 6.03925 6.90199 6.00511C6.42524 5.97096 5.94673 6.03975 5.49891 6.20681C5.05108 6.37387 4.64443 6.63528 4.30651 6.97333L2.30658 8.97333C1.69941 9.602 1.36344 10.444 1.37104 11.318C1.37863 12.192 1.72918 13.028 2.34719 13.6461C2.96519 14.2641 3.8012 14.6147 4.67516 14.6222C5.54912 14.6298 6.3911 14.2939 7.01975 13.6867L8.15971 12.5467",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3534_1881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9994,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink03);
export default __webpack_public_path__ + "static/media/link-03.404d32f9742c8aba966022673559f0ff.svg";
export { ForwardRef as ReactComponent };